import { Article } from "../interfaces/Article";
import { getUserPrice, normalizeAutoPartnerPrice } from "./pricingUtils";

export function getArticleLiveQueryKey(article: Article) {
  const articleNumber = article.articleNumber?.replace(/\//g, "*") ?? "";
  return ["liveArticle", articleNumber, article.dataSupplierId] as const;
}

export function canFetchLiveArticleState(article: Article): boolean {
  const articleNumber = article.articleNumber?.replace(/\//g, "*") ?? "";
  return Boolean(articleNumber && article.dataSupplierId != null);
}

export function isArticleAvailableForSale(liveData: unknown): boolean {
  if (!liveData || typeof liveData !== "object") {
    return false;
  }

  const data = liveData as {
    priceNet?: number;
    priceRetail?: number;
    totalStock?: number;
  };

  const priceNet = data.priceNet ?? 0;
  const priceRetail = data.priceRetail ?? 0;
  const articlePrice = normalizeAutoPartnerPrice(priceNet, priceRetail);
  const price = getUserPrice(articlePrice);
  const totalStock = Math.max(0, data.totalStock ?? 0);

  return totalStock > 0 && price > 0;
}
